import React, { useEffect, useState } from 'react';
import { api } from '../utils/apiHelper';
import '../styles/WebPopUp.css';
//dark
const WebPopUp = ({ onClose, truncate = false, variant = '' }) => {
  const [popCustom, setPopCustom] = useState(null);
   const publishing = `publishing.png`;

  useEffect(() => {
    const fetchActivePopCustom = async () => {
      try {
        const res = await api('/get-active-popcustom', 'GET');
        if (res && res.activePopCustom) {
          setPopCustom(res.activePopCustom);
          console.log("it got the custom");
        }
      } catch (err) {
        console.error('Error fetching active PopCustom:', err);
      }
    };

    fetchActivePopCustom();
  }, []);

  if (!popCustom) return null;

  return (
    <div className="webpop-overlay">

      <div className={`webpop-card ${variant}`}>
        <button className="webpop-close" onClick={onClose}>×</button>
<img src={publishing}  className="publishing" />
        <h1 style={parseStyleString(popCustom.headerStyle)}>{popCustom.header}</h1>

 {popCustom.imageUrl && (
          <img
            src={popCustom.imageUrl}
            alt={popCustom.header || 'Popup image'}
            className="webpop-image"
          />
        )}

        <p style={parseStyleString(popCustom.paragraph?.style)}>
          {truncate && popCustom.paragraph?.text
            ? popCustom.paragraph.text.slice(0, 100) + '...'
            : popCustom.paragraph?.text}
        </p>

        {popCustom.linkAddress ? (
          <a href={popCustom.linkAddress} target="_blank" rel="noopener noreferrer">
            <button className="webpop-button">{popCustom.buttonLabel}</button>
          </a>
        ) : (
          <button className="webpop-button">{popCustom.buttonLabel}</button>
        )}
      </div>
    </div>
  );
};

// Helper to convert style string to inline style object
const parseStyleString = (styleStr) => {
  if (!styleStr) return {};
  return styleStr.split(';').reduce((acc, rule) => {
    const [key, value] = rule.split(':').map((s) => s.trim());
    if (key && value) {
      const camelKey = key.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
      acc[camelKey] = value;
    }
    return acc;
  }, {});
};

export default WebPopUp;
